import { render, staticRenderFns } from "./form-exercise.vue?vue&type=template&id=29418cda"
import script from "./form-exercise.vue?vue&type=script&lang=js"
export * from "./form-exercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports